module.exports = __webpack_public_path__ + "static/media/CredNeoNew.b2fbe77e.svg";